export default "__VITE_ASSET__3io1uc05__"